import Routes from './routes'

import AppContext from './hooks'

function App() {
  return (
    <AppContext>
      <Routes />
    </AppContext>
  );
}

export default App;
